import request from '@/utils/request'

// 获取列表
export function queryList(query) {
  return request({
    url: '/business/about/list',
    method: 'get',
    params: query
  })
}